// UcFirst
String.prototype.ucFirst = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
};

// Capitalize
String.prototype.capitalize = function () {
    return this.ucFirst();
};

// Parse Number
String.prototype.parseNumber = function (int) {
    let target = this;
    target = target.replaceAll(',', '');
    target = target.replace('$', '');

    if (typeof int !== 'undefined') {
        return parseInt(target);
    }

    return parseFloat(target);
};

// Str Replace
String.prototype.replaceAll = function (search, replacement) {
    let target = this;
    return target.replace(new RegExp(search, 'g'), replacement);
};

// Snake Case
String.prototype.snakeCase = function () {
    return this.replace(/([A-Z])/g, '_$1').toLowerCase();
};

// Camel Case
String.prototype.camelCase = function () {
    return this.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '');
};

// Camel to Words
String.prototype.camelToWords = function () {
    return this.replace(/([A-Z]+)/g, ' $1').replace(/([A-Z][a-z])/g, ' $1');
};

// Get name initials
String.prototype.getInitials = function () {
    var initials = this.replace(/[^a-zA-Z- ]/g, "").match(/\b\w/g);

    if (!initials) {
        return '';
    }

    return initials.join('');

};

String.prototype.camelToSnakeCase = function (){
    return this.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
};

// Random String Generator
export function generateRandomString(length, chars) {
    if (typeof length === 'undefined') {
        length = 7;
    }
    if (typeof chars === 'undefined') {
        chars = '#aA';
    }

    let mask = '';
    if (chars.indexOf('a') > -1) mask += 'abcdefghijklmnopqrstuvwxyz';
    if (chars.indexOf('A') > -1) mask += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    if (chars.indexOf('#') > -1) mask += '0123456789';
    if (chars.indexOf('!') > -1) mask += '~`!@#$%^&*()_+-={}[]:";\'<>?,./|\\';
    let result = '';
    for (let i = length; i > 0; --i) result += mask[Math.round(Math.random() * (mask.length - 1))];
    return result;
}

export const bytesFormatter = (bytes) => {
    if (bytes === 0) {
        return '0 Bytes';
    }

    const k = 1000;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
};

export function formatStringPhoneUS(phoneString) {
    //remove int prefix
    let plain = phoneString.replace('+1', '');
    plain = plain.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    return !plain[2] ? plain[1] : plain[1] + '-' + plain[2] + (plain[3] ? '-' + plain[3] : '');
}

export function formatPhoneNumber(value) {
    let x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');

    return value;
}

/**
 * This method is case sensitive
 *
 * Example:
 * string: 'Test Something', search: 'Som' --> Result: 'Test <b>Som</b>ething'
 * string: 'Test Something', search: 'ome' --> Result: 'Test S<b>ome</b>ething'
 *
 * @param string
 * @param search
 * @returns {*}
 */
export function makeSubStringBold(string, search) {
    const re = new RegExp(search, 'gi'); // global, insensitive
    return string.replace(re, `<b>$&</b>`);
}

export function capitalize(string) {
    return string.toLowerCase().split(' ')
        .map(s => s.charAt(0).toUpperCase() + s.substring(1))
        .join(' ');
}

/**
 * Replace variables in a string with values from an object, removing brackets and spaces
 * Example: replaceVariables('Hello {{ dear $name }}', {name: 'John'}) --> 'Hello dear John'
 * @param text
 * @param variables
 * @returns {*}
 */
export function replaceVariables(text, variables) {
    return text.replace(/\{\{([^{}]+)\}\}/g, function(match, group) {
        const hasDefinedVariable = group.match(/\$([^\s]+)/g)
            .some(variableMatch => variables[variableMatch.slice(1)] !== undefined);
        if (hasDefinedVariable) {
            return group.replace(/\$([^\s]+)/g, (variableMatch, variableName) => variables[variableName] || '').trim();
        } else {
            return '';
        }
    }).replace(/\s+([.,!:])/g, '$1');
}
